import { useCallback } from 'react'
import { dispatch } from 'store'
import { aiVideoThunks } from 'store/features/aiVideo/thunks'
import { IMyFilesMediaItem, IUploadMediaItem } from 'types/media'
import {
  useAiVideoFileValidator,
  useMediaLibValidator
} from './useAiVideoUploadUtils'
import { createReferenceMediaItem } from 'store/features/aiVideo/utils'
import { ReferenceMediaImageType } from 'types/aiVideo'
import { ReferenceMode } from 'containers/SubSidebar/AIVideoContent/consts'

export const useFrameHandlers = () => {
  const { createUploadHandler } = useAiVideoFileValidator()
  const { validateMediaLibFiles } = useMediaLibValidator()

  const getValidMediaLibFile = useCallback(
    (files: IMyFilesMediaItem[]) => {
      const valid = validateMediaLibFiles(files)
      return valid?.[0]?.filePath ?? null
    },
    [validateMediaLibFiles]
  )

  const addFrameFromMediaLib = useCallback(
    (type: ReferenceMediaImageType, files: IMyFilesMediaItem[]) => {
      const path = getValidMediaLibFile(files)
      if (!path) return
      const item = createReferenceMediaItem(type, path)
      dispatch(
        aiVideoThunks.addReferenceMediaItem({
          item,
          bucket: ReferenceMode.FRAMES
        })
      )
    },
    [getValidMediaLibFile]
  )

  const getUploadedItem = (files: File[] | FileList) => {
    const filesArray = Array.from(files)
    const file = filesArray[0]
    const uploadItem: IUploadMediaItem = {
      id: crypto.randomUUID(),
      type: 'image' as const,
      file
    }
    return uploadItem
  }

  const onUploadFrame = useCallback(
    (type: ReferenceMediaImageType) =>
      createUploadHandler(async (files: File[] | FileList) => {
        const uploadItem = getUploadedItem(files)
        await dispatch(aiVideoThunks.uploadFrameImage(type, [uploadItem]))
      }),
    [createUploadHandler]
  )
  const handleRemoveFrame = useCallback((id: string) => {
    dispatch(
      aiVideoThunks.removeReferenceMediaItem({
        id,
        bucket: ReferenceMode.FRAMES
      })
    )
  }, [])

  const handleSwap = useCallback(() => {
    dispatch(aiVideoThunks.swapFrames())
  }, [])

  return {
    addFrameFromMediaLib,
    onUploadFrame,
    handleRemoveFrame,
    handleSwap
  }
}
